import { httpCreate } from './http';

const http = httpCreate('/srv/user-domain');

export const userDomain = {
	getDomainStatus() {
		return http.get('/active-status');
	},
	activeDomain() {
		return http.put('/active');
	},
};
